import { connect } from 'react-redux';

import TranslateTextModal from './translate_text_modal.jsx';

import {
  getTranslationsCurrentLanguageIso,
  getTranslationsDefaultLanguageIso
} from 'zoomforth_codesbane_viewer/reducers/index.js';


const mapStateToProps = (state)=> {
  const currentLanguageIso = getTranslationsCurrentLanguageIso(state);
  const defaultLanguageIso = getTranslationsDefaultLanguageIso(state);

  return {
    currentLanguageIso,
    defaultLanguageIso
  };
};

const mapDispatchToProps = ()=> {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TranslateTextModal);
